import Vue from "vue";
import Vuex from "vuex";
import sessionVuexModule from "./session";
import registrationVuexModule from "./registration";
import sidemenuVuexModule from "./sidemenu";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    registration: registrationVuexModule,
    session: sessionVuexModule,
    sidemenu: sidemenuVuexModule,
  }
});
